import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const qualityManagementConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default qualityManagementConfig;
